import { createSlice } from "@reduxjs/toolkit"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

import { frozenStateReconciler } from "../../../Utils/persistHelpers"
import { logout } from "../../LoginPage/redux/auth.actions"
import { GLOBAL_FILTERS_SLICE_NAME } from "./globalFilters.constants"

const initialState = {
  filters: {
    user_email: []
  },
  testData: "false"
}

const slice = createSlice({
  name: GLOBAL_FILTERS_SLICE_NAME,
  initialState,
  reducers: {
    setGlobalFilters: (state, { payload }) => {
      if (payload?.testData) {
        state.testData = payload.testData
        return
      }
      if (payload) {
        state.filters = payload
      }
    },
    addGlobalFilter: (state, { payload: { key, value } }) => {
      if (!value || value.trim() === "") return

      const currentValues = state.filters[key] || []
      if (currentValues.includes(value)) return

      state.filters[key] = [...currentValues, value]
    },
    removeGlobalFilter: (state, { payload: key }) => {
      delete state.filters[key]
    },
    clearGlobalFilters: (state) => {
      state.filters = initialState.filters
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.filters = initialState.filters
    })
  }
})

export const globalFiltersActions = slice.actions
export const { setGlobalFilters, addGlobalFilter, removeGlobalFilter, clearGlobalFilters } =
  slice.actions

export const selectGlobalFilters = (state) => state[GLOBAL_FILTERS_SLICE_NAME].filters
export const selectTestData = (state) => state[GLOBAL_FILTERS_SLICE_NAME].testData

const PERSISTED_REDUCER_VERSION = 2

export const persistedReducer = persistReducer(
  {
    key: GLOBAL_FILTERS_SLICE_NAME,
    storage,
    whitelist: ["filters", "testData"],
    stateReconciler: frozenStateReconciler,
    version: PERSISTED_REDUCER_VERSION,
    migrate: async (state) => {
      if (state?._persist?.version < PERSISTED_REDUCER_VERSION) {
        return {
          ...state,
          ...initialState
        }
      }
      return state
    }
  },
  slice.reducer
)

export const reducer = persistedReducer
